module.exports = __webpack_public_path__ + "img/image18.580b70be.jpg";